import { useEffect, ReactNode } from 'react';
import { useLocation } from 'react-router';


interface RouteGuardPublicProps {
    children: ReactNode;
}

export const RouteGuardPublic = ({ children }: RouteGuardPublicProps) => {

    const location = useLocation();
    useEffect(() => {
        document.documentElement.classList = "theme-light";
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname])
    return (
        children
    );

};
